<template>
  <v-dialog
  v-if="shopId && (shopId === 'U310b4c8934a2781f2c8bdfd73e8f295f')"
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        class="theme--light v-btn v-btn--has-bg v-btn--is-elevated"
        style="letter-spacing: -0.5px;"
        rounded
        block
        v-bind="attrs"
        v-on="on"
      >
        <v-icon left>mdi-text-search-variant</v-icon>
        รายละเอียด
      </v-btn>
    </template>
    <v-card class="no-radius no-shadow">
      <v-toolbar
        class="no-shadow"
      >
        <v-btn
        class="theme--light v-icon"
          icon
          @click="dialog = false"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-toolbar-title class="font-weight-bold">รายการนัดหมาย</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-row class="m-2">
        <v-col>
          <h4>{{headDetails['ประเภทบริการ']}}</h4>
          <p v-for="config in headConfig" :key="config.key" class="d-flex align-center">
            <v-icon v-if="config.icon" left>{{ config.icon }}</v-icon>
            <span>{{ config.key }} {{ headDetails[config.key] }}{{ config.suffix }}</span>
          </p>
        </v-col>
      </v-row>
      <v-divider class="mx-4"></v-divider>
      <v-row class="d-flex flex-column m-2">
        <v-col cols="12">
          <v-row v-for="config in userConfig" :key="config.key">
            <v-col cols="6" xs="5" sm="5" md="5" lg="5" class="text-gray">{{ config.key }}</v-col>
            <v-col cols="6" xs="7" sm="7" md="7" lg="7" class="font-weight-bold">{{ userDetails[config.key] }}</v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-divider v-if="joyRideReserveNowDetails || joyRideInsuranceDetails || menuItem" class="mx-4"></v-divider>
      <v-row class="ma-2">
        <v-col class="font-weight-bold">
          <p v-if="joyRideReserveNowDetails">{{joyRideReserveNowDetails}}</p>
          <p  v-if="joyRideInsuranceDetails">{{joyRideInsuranceDetails}}</p>
          <p  v-if="menuItem">{{menuItem}}</p>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>
<script>
import axios from 'axios' // api

export default {
  components: {
  },
  data () {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      headDetails: '',
      userDetails: '',
      headConfig: [
        { key: 'สาขา', icon: 'mdi-map-marker-outline', suffix: '' },
        { key: 'วันที่นัดหมาย', icon: 'mdi-calendar-month-outline', suffix: '' },
        { key: 'เวลานัดหมาย', icon: 'mdi-clock-time-four-outline', suffix: ' น.' }
      ],
      userConfig: [
        { key: 'ชื่อ' },
        { key: 'เบอร์โทร' },
        { key: 'จุดหมายปลายทาง' },
        { key: 'ปลายทาง 2 (ถ้ามี)' },
        { key: 'เวลาที่ต้องถึงจุดหมายปลายทาง' },
        { key: 'ชื่อผู้รับบริการ' },
        { key: 'เบอร์โทรผู้รับบริการ' },
        { key: 'อายุผู้รับบริการ' },
        { key: 'เพศผู้รับบริการ' },
        { key: 'โรคประจำตัว' },
        { key: 'ใช้วีลแชร์หรือไม่ ? หมายเหตุ : ทางจอยไรด์ไม่มีวีลแชร์ให้บริการ ต้องการข้อมูลส่วนนี้เพื่อการดูแลในโรงพยาบาล' },
        { key: 'ต้องการความช่วยเหลืออื่นๆ (โปรดระบุ)' },
        { key: 'จุดประสงค์ของการนัดหมาย (พบแพทย์) เช่น ฉีดยา, ทำแผล, ติดตามผล เป็นต้น' },
        { key: 'ประวัติแพ้อาหารและแพ้ยา (หากมี มีอาการอย่างไร โปรดระบุ)' },
        { key: 'หมายเลขการจอง (สำหรับแอดมินเท่านั้น)' },
        { key: 'ระหว่างเดินทาง ต้องการฟังเพลงแนวไหน แจ้งได้เลยค่ะ' }
      ],
      menuItem: '',
      joyRideInsuranceDetails: '',
      joyRideReserveNowDetails: ''
    }
  },
  props: {
    bookNo: {type: String, default: ''},
    jobNo: {type: String, default: ''},
    shopId: {type: String, default: null}
  },
  async mounted () {
    await this.getDetails()
  },
  methods: {
    async getDetails () {
      console.log('test')
      try {
        await axios.post(this.$DNS_IP + '/Booking/setDetailsCopyLinkAddData/' + this.bookNo)
          .then(response => {
            let rs = response.data
            console.log('rs getDetails empWaiting', rs)
            this.headDetails = rs.empWaitingDetails.headDetails
            this.userDetails = rs.empWaitingDetails.userDetails
            this.addressDetails = rs.empWaitingDetails.address
            this.joyRideInsuranceDetails = rs.empWaitingDetails.joyRideInsuranceDetails
            this.joyRideReserveNowDetails = rs.empWaitingDetails.joyRideReserveNowDetails
            console.log('rs.empWaitingDetails.menuItem', rs.empWaitingDetails.menuItem)
            if (rs.empWaitingDetails.menuItem) {
              this.menuItem = JSON.parse(rs.empWaitingDetails.menuItem)[0].name
            } else {
              this.menuItem = ''
            }
            console.log('JSON.parse menuItem', this.menuItem)
            this.$emit('ReturnDetails', {'destinationDetails': this.userDetails['จุดหมายปลายทาง'], 'serviceDetails': this.headDetails['ประเภทบริการ'], jobNo: this.jobNo})
          })
      } catch (error) {
        console.error('Error getDetails:', error)
      }
    }
  }
}
</script>
<style scoped>
/* --- Start: เปลี่ยนสไตล์ปุ่ม default ของ Vuetify --- */
.theme--light.v-btn.v-btn--has-bg {
  background-color: white;
  color: #1B437C;
  border-radius: 4px;
  border: 1px solid #1B437C;
}
.v-btn--is-elevated {
  box-shadow: 0 0px 0px 0px;
}
/* --- End: เปลี่ยนสไตล์ปุ่ม default ของ Vuetify --- */
.text-gray {
  opacity: 0.5;
}
.theme--light .v-icon {
  color: inherit;
  /* ไม่ใช้ default theme--light ของ v-icon */
}
.no-shadow{
  box-shadow: none !important;
}
.no-radius {
  border-radius: 0 !important;
  border: 2px solid white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/DialogModels/EmpWaitingDetails.vue